import { useContext } from "react";
import { PaywallContext } from "./context";

export const usePaywallContext = () => {
  return useContext(PaywallContext);
};
